import { Record } from "src/app/models/record";

export class OpenDialog {
  static readonly type = '[Rating] - Open dialog';

  constructor(public record: Record) { }
}

export class PostComment {
  static readonly type = '[Rating] - Post comment';

  constructor(public comment: string) { }
}

export class PostRating {
  static readonly type = '[Rating] - Post rating';
}

export class SetRating {
  static readonly type = '[Rating] - Set rating';

  constructor(public rate: number) { }
}

export class GetRating {
  static readonly type = '[Rating] - Get rating';

  constructor(public record: Record) { }
}

export class CloseDialog {
  static readonly type = '[Rating] - Close dialog';
}
